<template>
  <div>
    <el-table :data="items" size="small" class="mt-10" v-loading="loading">
      <el-table-column label="配件分类" prop="template.name"></el-table-column>
      <el-table-column
        align="center"
        label="所属基地"
        prop="base.name"
      ></el-table-column>
      <el-table-column align="center" label="钻井" prop="well.well_number">
      </el-table-column>
      <el-table-column
        align="center"
        label="库存数量"
        prop="count"
        min-width="200"
      >
        <template slot-scope="scope">
          <el-link
            class="font-12"
            type="primary"
            :underline="false"
            @click="
              handleShowDetail(
                scope.row.base_id,
                scope.row.item_template_id,
                scope.row.drill_well_id
              )
            "
            >{{ scope.row.count }}</el-link
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    items: null,
    loading: false,
  },
  methods: {
    handleShowDetail(baseid, templateid, wellid) {
      let filter = {
        item_template_id: templateid,
        drill_well_id: wellid,
        base_id: baseid,
        page: 1,
        size: 10,
      }
      this.$router.push(`/instrument_items?filter=${JSON.stringify(filter)}`)
    },
  },
}
</script>